export default "__VITE_ASSET__CGDucmWQ__"